module.exports = __webpack_public_path__ + "static/media/SarahSwitek_15_ThatsAll_3.ec3a23d9.mp3";